import { getUserAccessByUserId } from "Api/userAccess/getUserAccessByUserId.request";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

type LoadCurrentUserProjectAccessThunkArgs = {
  projectId: string;
  userId: string;
};

/**
 * Loads the connected user's own permissions on a project. Unlike
 * getUserAccessByUserIdThunk, it skips the ref:users resolution and is stored
 * per project, so navigating between projects never reads a stale role.
 */
export const loadCurrentUserProjectAccessThunk = createAppAsyncThunk(
  "userAccess/loadCurrentUserProjectAccess",
  async ({ projectId, userId }: LoadCurrentUserProjectAccessThunkArgs) => {
    const access = await getUserAccessByUserId(projectId, userId);

    return access.permissions;
  }
);
